import { colorSystem } from '@luminovo/design-system';
import { styled, TableCell } from '@mui/material';

export const RightAlignedStickyTableCell = styled(TableCell)({
    position: 'sticky',
    right: 0,
    backgroundColor: colorSystem.neutral.white,
});
